var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6224 3.67173C28.3707 1.36845 31.6293 1.36845 32.3776 3.67173L36.6559 16.8389C37.3922 19.105 39.504 20.6393 41.8867 20.6393H55.7315C58.1533 20.6393 59.1603 23.7384 57.201 25.1619L46.0003 33.2996C44.0726 34.7002 43.266 37.1827 44.0023 39.4488L48.2806 52.616C49.029 54.9193 46.3928 56.8346 44.4335 55.4111L33.2328 47.2733C31.3051 45.8728 28.6949 45.8728 26.7672 47.2733L15.5665 55.4111C13.6072 56.8346 10.971 54.9193 11.7194 52.616L15.9977 39.4488C16.734 37.1827 15.9274 34.7002 13.9997 33.2996L2.79901 25.1619C0.839727 23.7384 1.84666 20.6393 4.26847 20.6393H18.1133C20.496 20.6393 22.6078 19.105 23.3441 16.8389L27.6224 3.67173Z",
    stroke: "#2F4DC4",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star2.f693d0cd85eb41451799d5a6d76bf402.svg";
export { ForwardRef as ReactComponent };